import Swiper, { Pagination } from 'swiper';

export default function initHeaderSingle(): void {
    const $headerSingleContainer = document.querySelectorAll<HTMLElement>('.js-single-image');

    $headerSingleContainer.forEach($container => {
        new HeaderSingle($container);
    });
}

class HeaderSingle {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = $el?.querySelector('.single-slider');
        this.init();
    }

    init(): void {
        this.initSlider();
    }

    initSlider() {
        if (this.$slider) {
            this.swiper = new Swiper(this.$slider, {
                modules: [Pagination],
                slidesPerView: 1,
                pagination: {
                    el:'.swiper-pagination',
                    clickable: true,
                }
            });
        }
    }
}